import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { AdditionalNavDrawerLink } from "~/features/app/landing-header/nav-drawer/additional-nav/additional-nav-drawer-link";
const fragment = graphql(`
  fragment LandingNavDrawerAdditionalLinks on navDrawerAdditionalLinks_NeoField {
    ...LandingAdditionalNavDrawerLink
  }
`);
type Props = {
  navLinks: FragmentType<typeof fragment>[];
};
export function AdditionalDrawerNavigation(props: Props) {
  const {
    navLinks
  } = props;
  const links = useFragment(fragment, navLinks);
  if (!hasItems(links)) {
    return null;
  }
  return <_StyledUl>
      {links.map((link, idx) => <li key={idx}>
          <AdditionalNavDrawerLink {...link} />
        </li>)}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "additional-nav___StyledUl",
  componentId: "sc-2iv4j9-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "1.6rem",
  "padding": "2.4rem"
});